import { atom } from 'recoil';

export const clubUserDetailsAtom = atom({
  key: 'clubUserDetails',
  default: [],
});

export const userRaceClubOfficerClubAtom = atom({
  key: 'userRaceClubOfficerClub',
  default: [],
});

export const userDistrictsAtom = atom({
  key: 'userDistricts',
  default: [],
});
